export const isDemo = process.env.REACT_APP_DISABLE_DEMO_FEATURES === 'true';
